import { commonErrorApiCodeCtf } from "./errors-api-code-ctf";
import { commonErrorApiCodeResourcesCtf } from "./errors-api-code-resources-ctf";

// Domain error-code dictionary, composed by the owning app transport.
// Assembled only from generated own namespaces, never from the monolithic catalog.
export const errorCodeDomain = {
  apiCodes: {
    ...commonErrorApiCodeCtf,
  },
  apiCodeResources: {
    ...commonErrorApiCodeResourcesCtf,
  },
  apiCodeReasons: {
  },
} as const;
